<app-login-page>
  @if(loading) {
  <app-spinner>
    Loading...
  </app-spinner>
  } @else {
  <div class="container">

    <button type="button" class="btn btn-secondary btn-max-width btn--nomidio" (click)="loginWithNomidio()">
      <img alt="Nomidio" src="assets/default/nomidio-icon.svg">
      Sign in with Nomidio ID
    </button>

    @if (oauthError) {
      <div class="error-container">
        <img alt="Alert" src="/assets/default/alert.svg">
        <p class="error">
          @switch (oauthError) {
            @case (OauthError.AuthorisationError) {
              Authorisation with Nomidio ID failed.
            }
            @case (OauthError.InvalidParameters) {
              Sign-in failed, code or state is invalid.
            }
            @case (OauthError.UnexpectedFailure) {
              An unexpected error has occured, sign in with Nomidio ID failed.
            }
          }
        </p>
      </div>
    }

    @if(showUsernameLogin()) {
    <hr>

    <form [formGroup]="loginForm" (submit)="login()">
      <app-text-input [bold]="false" [control]="email" [errors]="emailErrors" name="Email Address" type="email">
      </app-text-input>
      <app-text-input [bold]="false" [control]="password" [errors]="passwordErrors" name="Password" type="password">
      </app-text-input>
      <div class="button-group">
        <button type="button" class="btn btn-link" [routerLink]="['reset']">Forgot password</button>
        <button type="submit" class="btn btn-primary btn-wide" [disabled]="busy || loginForm.invalid">Log In</button>
      </div>
    </form>

    @if (error) {
      <div class="error-container">
        <img alt="Alert" src="/assets/default/alert.svg">
        <p class="error">
          @switch (error) {
            @case (LoginError.InvalidCredentials) {
              Your authentication information is incorrect. Please try again.
            }
            @case (LoginError.LoginTimeout) {
              Your token has expired. Please log in again.
            }
          }
        </p>
      </div>
    }
    }
  </div>
  }
</app-login-page>
